import axios from 'axios'
import { ENDPOINT_USER_TRANSACTIONS } from '../../constants'
import { Transaction } from './data'

export const retrieveTransactions = async (clientId: string, limit: number = 50): Promise<Transaction[]> => {
    try {
        const response = await axios.get(ENDPOINT_USER_TRANSACTIONS, {
            params: {
                client: clientId,
                limit: limit
            }
        })

        if (response.data && response.data.Msg) {
            return response.data.Msg as Transaction[]
        }

        return []
    } catch (error: any) {
        console.error('Error retrieving transactions:', error)
        throw new Error(error.response?.data?.msg || 'Failed to retrieve transaction history')
    }
}

export const clearTransactionCache = () => {
    // Placeholder for any cache clearing logic if needed in the future
}